goog.provide("shadow.js.shim.module$$mui$material$ToggleButtonGroup");
goog.provide("module$shadow_js_shim_module$$mui$material$ToggleButtonGroup");
shadow.js.shim.module$$mui$material$ToggleButtonGroup = shadow.js.nativeProvides["@mui/material/ToggleButtonGroup"] = shadow$bridge("@mui/material/ToggleButtonGroup");
module$shadow_js_shim_module$$mui$material$ToggleButtonGroup.default = shadow.js.shim.module$$mui$material$ToggleButtonGroup;
